var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{attrs:{"id":"title"}},[_vm._v(_vm._s(_vm.$t('确认清除缓存'))+"?")]),_c('Row',[_c('Button',{staticStyle:{"margin-left":"20px","width":"100px"},attrs:{"type":"primary","size":"large","icon":"ios-leaf-outline"},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t('确定')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }